'use client';

import { PERSONA_THEMES } from '@/shared/themes/personaTheme';
import type { Persona } from '@/shared/types/survey';

// ─────────────────────────────────────────────────
// AmbientBlobs — floating gradient blobs per persona
// CSS-only animation for performance (no framer-motion).
// ─────────────────────────────────────────────────

interface AmbientBlobsProps {
  persona: Persona;
  count?: 2 | 3;
  opacity?: number;
  className?: string;
}

const BLOB_CONFIGS = [
  { size: 'w-72 h-72', position: '-top-20 -right-20', delay: '' },
  { size: 'w-56 h-56', position: '-bottom-16 -left-16', delay: 'animation-delay-2000' },
  { size: 'w-48 h-48', position: 'top-1/3 right-1/4', delay: 'animation-delay-4000' },
];

export default function AmbientBlobs({
  persona,
  count = 2,
  opacity = 0.1,
  className = '',
}: AmbientBlobsProps) {
  const theme = PERSONA_THEMES[persona];
  const blobs = BLOB_CONFIGS.slice(0, count);

  return (
    <div
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      aria-hidden="true"
    >
      {blobs.map((blob, i) => (
        <div
          key={i}
          className={`absolute ${blob.size} ${blob.position} rounded-full animate-blob blur-3xl ${blob.delay}`}
          style={{
            background: `radial-gradient(circle, ${i === 0 ? theme.colors.primary : theme.colors.accent}${Math.round(opacity * 255).toString(16).padStart(2, '0')}, transparent 70%)`,
          }}
        />
      ))}
    </div>
  );
}
